import React from "react";
import { Navigate, useLoaderData } from "react-router-dom";
import { LoaderData } from "../loaders";
import { KnownPermission, usePermissions } from "@genai/permissions";
import { ErrorFallback, LoaderFallback } from "@genai/fallback";

export const LandingPage = (): React.ReactElement => {
  const { allowed: isAdmin, loading } = usePermissions([
    KnownPermission.ADMIN,
    KnownPermission.SUPERADMIN,
  ]);
  const loaderData = useLoaderData() as LoaderData;
  const { defaultAssistant } = loaderData;

  return defaultAssistant ? (
    <Navigate to={`/assistant/${defaultAssistant.uuid}/chat`} />
  ) : loading ? (
    <LoaderFallback />
  ) : isAdmin ? (
    <Navigate to="/admin/assistant" />
  ) : (
    <ErrorFallback error="Aucun assistant n'a été attribué à votre organisation, veuillez contacter l'administrateur pour en obtenir un." />
  );
};
